import { normalizeAddress } from './address';

export const DELIVERY_TARGET_KEY = 'mytownly_delivery_target';

export const loadDeliveryTarget = () => {
  try {
    const raw = sessionStorage.getItem(DELIVERY_TARGET_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed?.address) parsed.address = normalizeAddress(parsed.address);
    return parsed;
  } catch {
    return null;
  }
};

export const saveDeliveryTarget = (target) => {
  try {
    if (target) sessionStorage.setItem(DELIVERY_TARGET_KEY, JSON.stringify(target));
    else sessionStorage.removeItem(DELIVERY_TARGET_KEY);
  } catch { /* private mode */ }
};

export const clearDeliveryTarget = () => saveDeliveryTarget(null);

export const DELIVERY_SESSION_KEY = 'mytownly_delivery_session_ok';

export const loadDeliverySession = () => {
  try {
    return sessionStorage.getItem(DELIVERY_SESSION_KEY) === '1';
  } catch {
    return false;
  }
};

export const saveDeliverySession = () => {
  try {
    sessionStorage.setItem(DELIVERY_SESSION_KEY, '1');
  } catch { /* private mode */ }
};

export const clearDeliverySession = () => {
  try {
    sessionStorage.removeItem(DELIVERY_SESSION_KEY);
  } catch { /* */ }
};

/** Set on successful OTP login; consumed once to show the location sheet. */
export const PENDING_LOCATION_PROMPT_KEY = 'mytownly_pending_location_prompt';

export const markPendingLocationPrompt = () => {
  try {
    sessionStorage.setItem(PENDING_LOCATION_PROMPT_KEY, '1');
  } catch { /* */ }
};

export const consumePendingLocationPrompt = () => {
  try {
    const pending = sessionStorage.getItem(PENDING_LOCATION_PROMPT_KEY) === '1';
    if (pending) sessionStorage.removeItem(PENDING_LOCATION_PROMPT_KEY);
    return pending;
  } catch {
    return false;
  }
};

export const clearPendingLocationPrompt = () => {
  try {
    sessionStorage.removeItem(PENDING_LOCATION_PROMPT_KEY);
  } catch { /* */ }
};

export const clearAllDeliveryStorage = () => {
  clearDeliveryTarget();
  clearDeliverySession();
  clearPendingLocationPrompt();
};
